import { useNavigate } from 'react-router-dom';
import useUser from '../../auth/useUser';

const VOTES = [
  { av: 'JP', bg: 'var(--purple)', name: 'Jan Pieters — Commercial', note: '"Strong tender opportunity. 60/40 split viable anchor. Competitive window open now."', date: 'Mar 15' },
  { av: 'SL', bg: 'var(--amber)', name: 'Sophie Linders — Legal', note: '"NDA reviewed. No IP conflicts. Standard in-licensing terms applicable."', date: 'Mar 15' },
  { av: 'MV', bg: 'var(--green)', name: 'Maria van den Berg — Regulatory Affairs', note: '"DCP route, 14-month timeline. No blocking issues. CBG dossier pre-assessed."', date: 'Mar 14' },
];

export default function MDApprovalModal({ show, onClose }) {
  const navigate = useNavigate();
  const { displayName, initials } = useUser();

  const handleApprove = () => {
    onClose();
    navigate('/pipeline');
  };

  if (!show) return null;

  return (
    <div className="modal-backdrop-fo" onClick={onClose}>
      <div className="modal-fo wide" onClick={e => e.stopPropagation()}>
        <button className="mcl" onClick={onClose}>✕</button>

        {/* Header */}
        <div className="d-flex align-items-center gap-3 mb-4">
          <div className="d-flex align-items-center justify-content-center rounded-3" style={{ width: 46, height: 46, background: 'var(--gold2)', border: '2px solid var(--gold)', fontSize: 22 }}>🏛</div>
          <div className="flex-grow-1">
            <div className="m-title mb-0">Portfolio Committee — MD Approval</div>
            <div style={{ fontSize: 12, color: 'var(--t3)' }}>Valsartan 160 mg · Sandoz NL · All 3 committee members voted GO</div>
          </div>
          <span className="ai-badge ms-auto">✦ Nova: GO</span>
        </div>

        {/* KPI row */}
        <div className="row g-2 mb-3">
          {[
            { label: '4Y Revenue', value: '€14.1M', color: 'var(--green)', bg: 'var(--green2)' },
            { label: 'Market Share Y1', value: '12%', color: 'var(--teal)', bg: 'var(--teal3)' },
            { label: 'Nova Decision', value: '✓ GO', color: 'var(--gold)', bg: 'var(--gold2)' },
          ].map((k, i) => (
            <div className="col-4" key={i}>
              <div className="p-3 rounded-2 text-center" style={{ background: k.bg }}>
                <div style={{ fontSize: '9.5px', color: 'var(--t3)' }}>{k.label}</div>
                <div style={{ fontSize: 20, fontWeight: 800, color: k.color, fontFamily: "'Syne',sans-serif" }}>{k.value}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Committee votes */}
        <div className="d-flex flex-column gap-2 mb-3">
          {VOTES.map((v, i) => (
            <div key={i} className="d-flex align-items-start gap-3 p-3 rounded-2" style={{ background: 'var(--green2)' }}>
              <div className="d-flex align-items-center justify-content-center rounded-2 text-white" style={{ width: 30, height: 30, background: v.bg, fontWeight: 700, fontSize: '10.5px', flexShrink: 0 }}>{v.av}</div>
              <div className="flex-grow-1">
                <div style={{ fontSize: '12.5px', fontWeight: 600 }}>{v.name}</div>
                <div style={{ fontSize: '11.5px', color: 'var(--t2)' }}>{v.note}</div>
              </div>
              <span className="pill p-g">✓ GO</span>
              <span style={{ fontSize: 10, color: 'var(--t3)', marginLeft: 6 }}>{v.date}</span>
            </div>
          ))}
          {/* MD row — awaiting */}
          <div className="d-flex align-items-start gap-3 p-3 rounded-2" style={{ background: 'var(--gold2)', border: '1.5px solid var(--gold)' }}>
            <div className="d-flex align-items-center justify-content-center rounded-2 text-white" style={{ width: 30, height: 30, background: 'var(--gold)', fontWeight: 700, fontSize: '10.5px', flexShrink: 0 }}>{initials}</div>
            <div className="flex-grow-1">
              <div style={{ fontSize: '12.5px', fontWeight: 700 }}>{displayName} — Managing Director</div>
              <div style={{ fontSize: '11.5px', color: 'var(--amber)' }}>⚡ Your signature is the final gate — advances project to Negotiate stage</div>
            </div>
            <span className="pill p-o">Awaiting MD</span>
          </div>
        </div>

        {/* Nova recommendation */}
        <div className="p-3 rounded-3 mb-3" style={{ background: 'linear-gradient(135deg,var(--teal3),var(--purple2))', fontSize: 12, color: 'var(--navy)', lineHeight: 1.6 }}>
          <strong>✦ Nova recommendation:</strong> All committee members voted GO. BC revised upward +€180K after Farminform Q1 refresh. Competitive window is open — 2 competitors delisted Q1 2026. Recommend immediate approval.
        </div>

        {/* Actions */}
        <div className="d-flex justify-content-end gap-2 flex-wrap pt-3 border-top">
          <button className="btn btn-s btn-sm" onClick={() => { onClose(); navigate('/bc/editor'); }}>Review Full BC</button>
          <button className="btn btn-s btn-sm" onClick={onClose}>Comment</button>
          <button className="btn btn-sm" style={{ background: 'var(--red2)', color: 'var(--red)', border: '1.5px solid rgba(214,59,10,.25)' }} onClick={onClose}>Return</button>
          <button className="btn btn-sm" style={{ background: 'var(--green)', color: '#fff' }} onClick={handleApprove}>🏛 Approve — Move to Negotiate</button>
        </div>
      </div>
    </div>
  );
}
